if (!window.TabsWithSlidersInstance) {
  window.TabsWithSlidersInstance = true;

  class TabsWithSliders {
    constructor(container) {
      this.container = container;
      this.tabs = container.querySelectorAll('.tabs-with-sliders__tab');
      this.panels = container.querySelectorAll('.tabs-with-sliders__slider-hld');
      this.swipers = [];
      
      this.init();
    }
    
    init() {
      // Add click event listeners to tabs
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', (e) => this.handleTabClick(e, index));
      });
      
      // Initialize Swiper for each slider
      this.initSwipers();
    }
    
    buildSwiperConfig(slider) {
      return {
        slidesPerView: 2,
        spaceBetween: 12,
        watchSlidesProgress: true,
        grabCursor: true,
        freeMode: {
          enabled: true,
          sticky: false,
          momentum: true
        },
        navigation: {
          nextEl: slider.querySelector('.tabs-with-sliders__slider-nav .swiper-button-next'),
          prevEl: slider.querySelector('.tabs-with-sliders__slider-nav .swiper-button-prev'),
        },
        pagination: {
          el: slider.querySelector('.tabs-with-sliders__pagination'),
          clickable: true,
        },
        breakpoints: {
          576: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
            freeMode: { enabled: false },
          },
          1280: {
            slidesPerView: 4,
            spaceBetween: 20,
            freeMode: { enabled: false }
          },
          1440: {
            slidesPerView: 5,
            spaceBetween: 20,
            freeMode: { enabled: false }
          }
        }
      };
    }

    initSwipers() {
      const sliders = this.container.querySelectorAll('.tabs-with-sliders__slider');

      // Only init the first (visible) slider on load — inactive tab swipers are
      // lazy-inited on first tab click to avoid forced reflow on hidden elements.
      sliders.forEach((slider, index) => {
        if (index === 0) {
          this.swipers[index] = new Swiper(slider, this.buildSwiperConfig(slider));
        } else {
          this.swipers[index] = null;
          slider._swiperEl = slider;
        }
      });
    }
    
    handleTabClick(event, index) {
      event.preventDefault();
      this.switchToTab(index);
    }
    
    switchToTab(index) {
      // Remove active state from all tabs and panels
      this.tabs.forEach((tab, i) => {
        tab.classList.toggle('is-active', i === index);
        tab.setAttribute('aria-selected', i === index);
        tab.setAttribute('tabindex', i === index ? '0' : '-1');
      });

      this.panels.forEach((panel, i) => {
        panel.classList.toggle('is-active', i === index);
        panel.setAttribute('aria-hidden', i !== index);
      });

      // Lazy-init swiper for this tab if not yet created, then update dimensions
      const slider = this.container.querySelectorAll('.tabs-with-sliders__slider')[index];
      if (slider) {
        if (!this.swipers[index]) {
          this.swipers[index] = new Swiper(slider, this.buildSwiperConfig(slider));
        } else {
          this.swipers[index].update();
        }
      }
    }
  }

  // Initialize tabs when DOM is loaded
  document.addEventListener('DOMContentLoaded', () => {
    const tabContainers = document.querySelectorAll('.tabs-with-sliders');
    tabContainers.forEach(container => {
      new TabsWithSliders(container);
    });
  });
}